import {
  Location,
  LocationStrategy,
  PathLocationStrategy
} from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';
import { Moment } from 'moment';
import { CommonService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';
import { AlertService } from 'src/app/shared';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY'
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-water-report',
  templateUrl: './water-report.component.html',
  styleUrls: ['./water-report.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS
    },
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ]
})

/**
 *
 *
 * @export
 * @class WaterReportComponent
 * @implements {OnDestroy}
 */
export class WaterReportComponent implements OnDestroy {
  siteId = '';
  siteName = '';
  max = new Date();
  date = new UntypedFormControl(moment());
  navigationSubscription: any;
  fileName: string;

  /**
   * Creates an instance of WaterReportComponent.
   * @param {CommonService} commonService
   * @param {DataService} dataService
   * @param {AlertService} alertService
   * @param {Router} router
   * @memberof WaterReportComponent
   */
  constructor(
    public commonService: CommonService,
    private dataService: DataService,
    private alertService: AlertService,
    private router: Router,
    public location: Location
  ) {
    //Get SiteId
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.siteId = localStorage.getItem('siteId');
        this.siteName = localStorage.getItem('siteName');
      }
    });
  }

  /**
   * Function to destroy subscriptions
   *
   * @memberof WaterReportComponent
   */
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  /**
   * Function to go back to overview page
   *
   * @memberof WaterReportComponent
   */
  backClick() {
    this.router.navigate(['site', 'over-view'], {
      queryParams: { siteId: this.siteId }
    });
  }

  /**
   * Function call happen when user clicks ok button with buttonId generate-excel-report
   *
   * @memberof WaterReportComponent
   */
  ok() {
    let url = '';
    let reportName = 'WaterReport';
    const selectedMonth = this.date.value.format('YYYY-MM');

    //API call to get Water Report url
    url = this.commonService.getUtilityReportUrl(
      this.siteId,
      'Water',
      selectedMonth
    );

    this.fileName = this.siteName + '_' + reportName + '_' + selectedMonth;

    this.dataService.getPDF(url, true).subscribe((response) => {
      if (response.byteLength > 0) {
        const file = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const fileURL = URL.createObjectURL(file);
        // Provide filename to the exported file
        const fileName = document.createElement('a');
        fileName.href = fileURL;
        fileName.download = this.fileName;
        fileName.click();
        URL.revokeObjectURL(fileURL);
      } else {
        this.alertService.message = 'No Data present for selected duration';
        this.alertService.showError();
      }
    });
  }

  goToBack() {
    this.location.back();
  }
}
